<template>
    <ul class="complain">
        <van-list
                v-model="loading"
                :finished="finished"
                :offset="10"
                finished-text="没有更多了"
                @load="onLoad">
            <li v-for="(item,index) in listData" :key="index">
                <div class="top">
                    <div>订单号：<span>{{item.id}}</span></div>
                    <div><span style="color: #ff4d30;">{{stateInfo(item.status)}}</span></div>
                </div>
                <div class="center">
                    <div>价格：<span>{{item.price}} RMB/USDT</span></div>
                </div>
                <div class="center">
                    <div>数量：<span>{{item.num}} USDT</span></div>
                </div>
                <div class="bottom">
                    <div>总额：</div>
                    <div><span>{{item.price * item.num}} RMB</span></div>
                </div>
            </li>
        </van-list>
    </ul>
</template>

<script>
    export default {
        name: "complain",
        data() {
            return {
                page: 0,
                total: null,
                loading: false,
                finished: false,
                listData: []
            }
        },
        methods: {
            getData() {
                this.page++;
                this.ajax.post('appapi/c2c/mycomplain', {page: this.page,}).then((res) => {
                    if (res.data.code === 1) {
                        this.listData.push(...res.data.data.data);
                        this.total = res.data.data.total;
                        // 加载状态结束
                        this.loading = false;
                        // 数据全部加载完成
                        if (this.listData.length >= this.total) {
                            console.log("加载完成");
                            this.finished = true;
                        }
                    }
                })
            },
            onLoad() {
                setTimeout(() => {
                    this.getData();
                }, 500);
            },
            stateInfo(state) {
                switch (state) {
                    case 0:
                        return "未处理";
                    case 1:
                        return "胜诉";
                    case 2:
                        return "重新申诉";
                    case 3:
                        return "败诉";
                    case 4:
                        return "撤诉";
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .complain {
        margin-top: 45px;
        padding: 0 35px;

        li {
            padding: 22px 38px 28px;
            background: #fff;
            box-shadow: 0 10px 29px 0 rgba(226, 226, 226, 0.5);
            border-radius: 20px;
            margin-bottom: 27px;

            .idBox {
                margin-bottom: 49px;
                font-size: 24px;
                font-weight: bold;
                color: rgba(51, 51, 51, 1);
                line-height: 20px;
            }

            .top, .center, .bottom {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 30px;

                div {
                    font-size: 24px;
                    font-weight: bold;
                    color: rgba(119, 119, 119, 1);
                    line-height: 20px;

                    span {
                        color: #1fc26d;
                    }
                }

                button {
                    width: 107px;
                    height: 41px;
                    line-height: 41px;
                    font-size: 22px;
                    font-weight: bold;
                    color: #fff;
                    box-shadow: 0 1px 15px 0 rgba(131, 131, 131, 0.2);
                    border-radius: 25px;
                    background: #FF4D30;
                }
            }

            .bottom {
                margin-bottom: 0;
            }
        }
    }
</style>
